/**
 * Two Shabbat candles in a single colour (`currentColor`), standing straight
 * up from behind the top-left of a person's circle: the sticks sit behind the
 * photo, the flames rise above the rim and flicker gently (not under reduced
 * motion). Decorative — the accessible label lives on the circle.
 */
export function ShabbatCandles({ className = '', still = false, title }: { className?: string; still?: boolean; title?: string }) {
  return (
    <svg className={`shabbat-candles ${still ? 'is-still' : ''} ${className}`} viewBox="0 0 32 76" aria-hidden={title ? undefined : true} role={title ? 'img' : undefined} focusable="false">
      {title ? <title>{title}</title> : null}
      {/* Both candles stand straight with their flames level. The sticks run all the way down to the
          bottom of the box — which the CSS places at the circle's centre — so however the rim curves
          away, each stick still reaches the circle and looks like it is coming out from behind it. */}
      <ellipse className="candle-glow" cx="16" cy="8" rx="15" ry="8" />
      <rect className="candle-wax" x="6.5" y="14" width="5.5" height="62" rx="1.5" />
      <rect className="candle-wax" x="20" y="14" width="5.5" height="62" rx="1.5" />
      <path className="candle-flame flame-a" d="M9.25 1.5c-2.6 3-3.2 5.6-1.7 7.8 1.3 1.9 3.8 1.8 4.9-.2 1-2 .1-4.7-3.2-7.6z" />
      <path className="candle-flame flame-b" d="M22.75 1.5c-2.6 3-3.2 5.6-1.7 7.8 1.3 1.9 3.8 1.8 4.9-.2 1-2 .1-4.7-3.2-7.6z" />
    </svg>
  );
}
